import {
    hideElement,
    showElement
} from '../../checkout/components/cart-functions';
const BUTTON = '[data-show-related]';
const ATTR_RELATED = 'data-related';
const ATTR_HIDDEN = 'aria-hidden';

export default function ShowRelatedContent() {
    let initCarousel = false;

    function hide($el) {
        $el.setAttribute(ATTR_HIDDEN, 'true');
        hideElement($el);
    }

    function hideAll() {
        document.querySelectorAll(`[${ATTR_RELATED}]`).forEach(hide);
    }

    eventDelegate.addEvent('click', BUTTON, (_, $el) => {
        const relatedContent = $el.getAttribute('data-show-related');
        const $content = document.querySelector(
            `[${ATTR_RELATED}="${relatedContent}"]`
        );
        if (!$content) return;

        const hidden = $content.getAttribute(ATTR_HIDDEN);
        hideAll();

        if (hidden === 'true') {
            $content.setAttribute(ATTR_HIDDEN, 'false');
            showElement($content);
            if (!initCarousel) {
                setTimeout(() => {
                    MNTK.emit('lazyInitCarousel');
                    initCarousel = true;
                }, 1);
            }
        } else {
            hide($content);
        }
    });
}
